import React, { Suspense } from "react";
import { Grid, Card, CardHeader, CardContent } from "@mui/material";
import { DeploymentListTable } from "../components/deployment";
import "../styles/deployment.css";
import DeploymentStats from "../components/deployment/DeploymentStats";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateDeploymentTile from "../components/deployment/CreateDeploymentTile";

const Deployments = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Suspense fallback={<StatSkeleton tiles={3} />}>
          <DeploymentStats />
        </Suspense>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <CreateDeploymentTile />
        </Grid>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <Card variant="outlined">
            <CardContent
              sx={{
                padding: 0,
                "&:last-child":{pb:0}
              }}
            >
              <DeploymentListTable />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Deployments;
